import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { loadContractEvents } from 'src/store/actions/contractActions';
import { selectContractEvents } from 'src/store/selectors/contractSelectors';
import ContractEventsDetail from './ContractEventsDetail';

const ContractEvents = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const contractEvents = useSelector(selectContractEvents);

  useEffect(() => {
    dispatch(loadContractEvents({ id }));
  }, [dispatch, id]);

  return (
    <Box mt={3} display="flex" flexDirection="column">
      <Box lg={12}>
        <ContractEventsDetail contractEvents={contractEvents} />
      </Box>
    </Box>
  );
};

export default ContractEvents;
